export const NOT_FOUND_ERROR_CODE = 404;
export const ACCESS_DENIED_ERROR_CODE = 401;
